import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';


function StudentDashboard() {
  const navigate = useNavigate();
  const [upcomingBookings, setUpcomingBookings] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);

  useEffect(() => {
    const fetchUpcomingBookings = async () => {
      try {
        const response = await api.get('/bookings/upcoming');
        console.log("response", response.data);
        // 根據日期和時段排序
        response.data.sort((a, b) => {
            // 先比較日期
            const dateComparison = moment(a.date).diff(moment(b.date));
            if (dateComparison !== 0) return dateComparison;
            
            // 日期相同時比較時段
            const timeSlotOrder = {
                'MORNING': 1,
                'AFTERNOON': 2
            };
            return timeSlotOrder[a.time_slot] - timeSlotOrder[b.time_slot];
        });
        setUpcomingBookings(response.data); 
      } catch (error) {
        console.error('Error fetching upcoming bookings:', error);
      }
    };

    fetchUpcomingBookings();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedBooking(null);
  };

  function BookingDetailModal() {
    if (!selectedBooking) return null;
    
    return (
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>課程詳情</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <h5>{selectedBooking.courseName}</h5>
            <hr />
            <p><strong>上課日期：</strong>{moment(selectedBooking.date).format('YYYY/MM/DD')}</p>
            <p>
              <strong>上課時段：</strong>
              {selectedBooking.time_slot === 'MORNING' ? '早上' : '下午'}
            </p>
            <p><strong>上課地點：</strong>{selectedBooking.preferred_location}</p>
            <p><strong>課程類型：</strong>{selectedBooking.type_display}</p>
            <p><strong>學生人數：</strong>{selectedBooking.numberof_students}</p>
            <p><strong>教練姓名：</strong>{selectedBooking.coach_name}</p>
            {selectedBooking.notes && (
              <p><strong>備註：</strong>{selectedBooking.notes}</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <div>
      <h2 className="mb-4">首頁</h2>
      <Row>
        <Col md={6}>
          <Card className="mb-3">
            <Card.Body>
              <Card.Title>預約記錄</Card.Title>
              <Card.Text>查看預約歷史</Card.Text>
              <Button onClick={() => navigate('/student/history')}>
                查看記錄
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="mb-3">
            <Card.Body>
              <Card.Title>課程預約</Card.Title>
              <Card.Text>
                預約新的課程
              </Card.Text>
              <Button 
                variant="primary"
                onClick={() => navigate('/student/booking')}
              >
                前往預約
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {upcomingBookings.length > 0 && (
        <div className="mb-4">
          <h5 className="mb-3">即將到來的課程</h5>
          {upcomingBookings.map((booking) => (
            <Alert 
              key={booking.id} 
              variant="info" 
              className="d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{booking.courseName}</strong>
                <div>
                  上課時間：{moment(booking.date).format('YYYY/MM/DD')}
                  <span 
                    className="me-2 px-2 py-1 rounded-2"
                    style={{ 
                      marginLeft: '10px',
                      backgroundColor: '#fff3cd',
                      color: '#997404',
                      fontSize: '0.875rem',
                      fontWeight: '500'
                    }}
                  >
                    {booking.time_slot === 'MORNING' ? '早上' : '下午'}
                  </span>
                </div>
                <div>
                  上課地點：{booking.preferred_location}
                </div>
                <div>
                  教師：{booking.coach_name}
                </div>
              </div>
              <Button 
                variant="outline-primary" 
                size="sm"
                onClick={() => {
                  setSelectedBooking(booking);
                  setShowModal(true);
                }}
              >
                查看詳情
              </Button>
            </Alert>
          ))}
        </div>
      )}
      <BookingDetailModal />
    </div>
  );
}

export default StudentDashboard; 